import { defineStore } from 'pinia'
import { reactive, readonly } from 'vue'

export interface IIntercomStoreState {
	isLaunched: boolean
	otherPosition?: {
		bottom?: number
		right?: number
	}
}

export interface IIntercomStore {
	readonly state: {
		isLaunched: boolean
		otherPosition?: {
			bottom?: number
			right?: number
		}
	}
	setIsLaunched: (isLaunched: boolean) => void
	getIsLaunched: ComputedRef<boolean>
	setOtherPosition: (bottom?: number, right?: number) => void
	getOtherPosition: ComputedRef<{ bottom?: number; right?: number } | undefined>
}

export const useIntercomStore = defineStore('intercomStore', (): IIntercomStore => {
	const _state = reactive<IIntercomStoreState>({
		isLaunched: false,
	})

	const setIsLaunched = (isLaunched: boolean): void => {
		_state.isLaunched = isLaunched
	}

	const getIsLaunched = computed(() => {
		return _state.isLaunched
	})

	const setOtherPosition = (bottom?: number, right?: number): void => {
		if (bottom || right) {
			_state.otherPosition = { bottom, right }
		} else {
			_state.otherPosition = undefined
		}
	}

	const getOtherPosition = computed(() => {
		return _state.otherPosition
	})

	return {
		state: readonly(_state),
		setIsLaunched,
		getIsLaunched,
		setOtherPosition,
		getOtherPosition,
	}
})
